import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import AdminTranslationForm from "./AdminTranslationForm";

const AdminEditTranslation = ({children, translation, onChange, sections, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const [form, setForm] = useState({
        name: translation.name,
        category: translation.category,
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        adminHttp
            .put('/translations/' + translation.id, form)
            .then(res => {
                setError(null);
                setShow(false);
                onChange();
            }).catch((error) => {
            setError(error.response?.data);
        });
    };

    return (
        <>
            <a {...rest} onClick={handleShow}>{children}</a>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Translation</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving translation!"}
                        </div>
                    )}

                    <AdminTranslationForm values={form} onChange={setForm} sections={sections} errors={error?.errors} />

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save Translation
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default AdminEditTranslation;
